// Résolution du poids et calcul des macros pour un produit identifié par code-barres (objectif § 5
// « passage aux grammes »). Séparé de `index.ts` pour rester testable sans tirer l'import WASM de
// ZXing que `index.ts` réexporte via `scanner.ts` (voir test/barcodeIndex.test.ts).
import type { MacrosPer100g, OffProduct } from './types.js';
import { scaleMacros } from './scaleMacros.js';

/**
 * Résout le poids à utiliser pour un produit identifié par code-barres : priorité à une saisie
 * utilisateur explicite, puis au `serving_size` fourni par Open Food Facts. `null` signifie
 * qu'aucun des deux n'est disponible : c'est au modèle vision d'estimer la quantité *de ce produit
 * déjà identifié* (composition exacte + quantité estimée) — combinaison qui reste hors de ce module
 * puisqu'elle dépend de `POST /api/analyze`, encore un stub 501 (CLAUDE.md § Contrat d'API).
 */
export function resolveGrams(product: OffProduct, userGrams: number | null | undefined): number | null {
  if (typeof userGrams === 'number' && Number.isFinite(userGrams) && userGrams > 0) {
    return Math.round(userGrams);
  }
  return product.servingGrams;
}

/** Macros pour le poids résolu (`resolveGrams`), ou `null` si le poids n'est pas encore connu. */
export function macrosForGrams(nutriments: MacrosPer100g, grams: number | null): MacrosPer100g | null {
  return grams === null ? null : scaleMacros(nutriments, grams);
}
